import { createFileRoute } from '@tanstack/react-router';
import ButtonDemoPage from '@/features/widget-demo/ButtonDemoPage';

export const Route = createFileRoute('/shops/button-demo')({
  component: ButtonDemoPage,
});
